import { Spinner } from 'components/Elements';
import { lazyImport } from 'utils/lazyImport';
import { Suspense } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
const { HomeRoutes } = lazyImport(() => import('features/home'), 'HomeRoutes');
const { AccountRoutes } = lazyImport(() => import('features/account'), 'AccountRoutes');
const { FavoritesRoutes } = lazyImport(() => import('features/favorites'), 'FavoritesRoutes');
const { GaragesRoutes } = lazyImport(() => import('features/garages'), 'GaragesRoutes');

const App = () => {
  return (
    <>
      <Suspense
        fallback={
          <div className="h-full w-full flex items-center justify-center">
            <Spinner size="xl" />
          </div>
        }
      >
        <Outlet />
      </Suspense>
    </>
  );
};

export const protectedRoutes = [
  {
    path: '/app',
    element: <App />,
    children: [
      { path: '/app/account/*', element: <AccountRoutes /> },
      { path: '/app/garages/*', element: <GaragesRoutes /> },
      { path: '/app/favorites/*', element: <FavoritesRoutes /> },
      { path: '/app/home/*', element: <HomeRoutes /> },
      { path: '*', element: <Navigate to="." /> },
    ],
  },
];
